// @ts-nocheck
import FeedbackToast from "./FeedbackToast";

export default function ErrorMessage({ messageErr, message, subtitleErr, subtitle, duration, onClose }) {
  return (
    <FeedbackToast
      type="error"
      message={messageErr || message}
      subtitle={subtitleErr || subtitle}
      duration={duration}
      onClose={onClose}
    />
  );
}
